import Vue from 'vue';
import Router from 'vue-router';

import sakip_home from './components/sakip/home/home.vue';

import sakip_pk_lv_1 from './components/sakip/perjanjian_kinerja/pk_lv_1.vue';
import sakip_pk_lv_2 from './components/sakip/perjanjian_kinerja/pk_lv_2.vue';
import sakip_pk_lv_3 from './components/sakip/perjanjian_kinerja/pk_lv_3.vue';
import sakip_pk_lv_4 from './components/sakip/perjanjian_kinerja/pk_lv_4.vue';

import sakip_ra_lv_1 from './components/sakip/rencana_aksi/ra_lv_1.vue';
import sakip_ra_lv_2 from './components/sakip/rencana_aksi/ra_lv_2.vue';
import sakip_ra_lv_3 from './components/sakip/rencana_aksi/ra_lv_3.vue';
import sakip_ra_lv_4 from './components/sakip/rencana_aksi/ra_lv_4.vue';

import sakip_realisasi_kinerja_keuangan from './components/sakip/realisasi_kinerja_keuangan/opd/realisasi_keuangan.vue';

import sakip_lap_perjanjian_kinerja from './components/sakip/laporan/lap_perjanjian_kinerja.vue';
import sakip_lap_rencana_aksi from './components/sakip/laporan/lap_rencana_aksi.vue';
import sakip_lap_monev from './components/sakip/laporan/lap_monev.vue';
import sakip_lap_pohon_kinerja from './components/sakip/laporan/pohon_kinerja.vue';


import sakip_lap_perencanaan from './components/sakip/laporan/perencanaan_kinerja/perencanaan.vue';



import sakip_iku_daerah from './components/sakip/realisasi_kinerja_keuangan/daerah/iku_daerah.vue';
import sakip_iku_opd from './components/sakip/realisasi_kinerja_keuangan/opd/iku_opd.vue';
import sakip_evaluasi_kinerja from './components/sakip/realisasi_kinerja_keuangan/evaluasi_kinerja/evaluasi_kinerja.vue';





// import './assets/css/kiken/kiken.css'

Vue.use(Router)



function loggedInRedirectDashboard(to, from, next) {
  if (localStorage.token) {
    next('/dashboard');
  } else {
    next();
  }
}

function isLoggedIn(to, from, next) {
  if (localStorage.token) {
    next();
  } else {
    next('/monev_login');
  }
}

var routes = [
    {
        path: '/sakip',
        name: '/sakip',
        component: sakip_home,
        beforeEnter: isLoggedIn,
    },
    {
        path: '/sakip_pk_lv_1',
        name: '/sakip_pk_lv_1',
        component: sakip_pk_lv_1,
        beforeEnter: isLoggedIn,
    },

    {
        path: '/sakip_pk_lv_2',
        name: '/sakip_pk_lv_2',
        component: sakip_pk_lv_2,
        beforeEnter: isLoggedIn,
    },

    {
        path: '/sakip_pk_lv_3',
        name: '/sakip_pk_lv_3',
        component: sakip_pk_lv_3,
        beforeEnter: isLoggedIn,
    },

    {
        path: '/sakip_pk_lv_4',
        name: '/sakip_pk_lv_4',
        component: sakip_pk_lv_4,
        beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_ra_lv_1',
      name: '/sakip_ra_lv_1',
      component: sakip_ra_lv_1,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/sakip_ra_lv_2',
      name: '/sakip_ra_lv_2',
      component: sakip_ra_lv_2,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/sakip_ra_lv_3',
      name: '/sakip_ra_lv_3',
      component: sakip_ra_lv_3,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/sakip_ra_lv_4',
      name: '/sakip_ra_lv_4',
      component: sakip_ra_lv_4,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_realisasi_kinerja_keuangan',
      name: '/sakip_realisasi_kinerja_keuangan',
      component: sakip_realisasi_kinerja_keuangan,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_lap_perjanjian_kinerja',
      name: '/sakip_lap_perjanjian_kinerja',
      component: sakip_lap_perjanjian_kinerja,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_lap_rencana_aksi',
      name: '/sakip_lap_rencana_aksi',
      component: sakip_lap_rencana_aksi,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_lap_monev',
      name: '/sakip_lap_monev',
      component: sakip_lap_monev,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_lap_pohon_kinerja',
      name: '/sakip_lap_pohon_kinerja',
      component: sakip_lap_pohon_kinerja,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/sakip_lap_perencanaan',
      name: '/sakip_lap_perencanaan',
      component: sakip_lap_perencanaan,
      beforeEnter: isLoggedIn,
    },

    {
      path: '/sakip_iku_daerah',
      name: '/sakip_iku_daerah',
      component: sakip_iku_daerah,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_iku_opd',
      name: '/sakip_iku_opd',
      component: sakip_iku_opd,
      beforeEnter: isLoggedIn,
    },
    {
      path: '/sakip_evaluasi_kinerja',
      name: '/sakip_evaluasi_kinerja',
      component: sakip_evaluasi_kinerja,
      beforeEnter: isLoggedIn,
    },
]


export default routes
